module.exports = __webpack_public_path__ + "media/lastdance.a3f1b408.mp3";